import React, { lazy, Suspense } from 'react';
export const SECTION_ID = 'entries';
import { staticImageAssets } from 'js/constants/Paths';
import { useSelector } from 'react-redux';

const Carousel = lazy(() => import('js/components/carousel/Carousel'));

import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

// import selectors
import { getCarouselEntries } from 'js/store/gallery/Gallery.selectors';

import ContentItemBlock from 'js/components/content-item/ContentItem.block.jsx';

const CarouselItems = () => {
  const carouselItems = useSelector((state) => {
    return getCarouselEntries(state);
  });

  return carouselItems.map((item) => {
    const { id } = item;
    return (
      <div key={id} className="header-region__slide" style={{ display: 'flex', justifyContent: 'center' }}>
        <ContentItemBlock item={item} carousel={true} />
      </div>
    );
  });
};

const HeaderRegionEntries = ({ title, description }) => {
  const slideRef = React.useRef(null);
  const prevRef = React.useRef(null);
  const nextRef = React.useRef(null);

  const hideArrows = () => {
    prevRef.current.style.display = 'none';
    nextRef.current.style.display = 'none';
  };

  const updateArrows = () => {
    if (slideRef.current && slideRef.current.swiper) {
      if (slideRef.current.swiper.isBeginning) {
        nextRef.current.style.display = 'flex';
        prevRef.current.style.display = 'none';

        return;
      }

      if (slideRef.current.swiper.isEnd) {
        nextRef.current.style.display = 'none';
        prevRef.current.style.display = 'flex';
        return;
      }
      nextRef.current.style.display = 'flex';
      prevRef.current.style.display = 'flex';
    }
  };

  const handleResize = () => {
    if (slideRef.current && slideRef.current.swiper) {
      if (window.innerWidth < 768) {
        slideRef.current.swiper.slides?.length > 1 ? updateArrows() : hideArrows();
      } else {
        slideRef.current.swiper.slides?.length > 3 ? updateArrows() : hideArrows();
      }
    }
  };

  const attachedArrows = () => {
    if (slideRef.current && slideRef.current.swiper) {
      slideRef.current.swiper.on('resize', handleResize);
      handleResize();
    }

    return () => {
      if (slideRef.current && slideRef.current.swiper) {
        slideRef.current.swiper.off('resize', handleResize);
      }
    };
  };

  return (
    <section id={SECTION_ID} className={`header-region header-region--${SECTION_ID}`}>
      <div className="container">
        <div className={`header-region__about-details`}>
          <SvgTextureLineLong color={'#fff'} />
          <h1>{title}</h1>
          <h2>{description}</h2>
        </div>
      </div>
    </section>
  );
};

export default HeaderRegionEntries;
